<div class="mt-4" *ngIf="title">
  <h5 class="edit_container_title">{{ title }}</h5>
</div>

<div class="feeSection">
  <div class="row mx-0 mt-2">
    <div class="scroll_outer NoSidePadding">
      <div class="scroll_inner" [ngClass]="{ 'fees_scroll_inner': readonly }">
        <div class="borderd_table">
          <table class="table table-hover table-striped mb-0" [ngClass]="{ 'feestable': readonly }">
            <colgroup>

  <!-- Module Type 2 -->
  <ng-container *ngIf="moduleType == 2">

    <col style="width: 5%;">
    <col style="width: 13%;">
    <col style="width: 8%;">
    <col style="width: 9%;">
    <col style="width: 13%;">
    <col style="width: 16%;">
    <col style="width: 16%;">
    <col style="width: 25%;">

  </ng-container>

  <!-- Module Type 1 / 3 -->
  <ng-container *ngIf="moduleType != 2">

    <col style="width: 5%;">
    <col style="width: 12%;">
    <col style="width: 10%;">
    <col style="width: 10%;">
    <col style="width: 10%;">
    <col style="width: 14%;" *ngIf="moduleType !== 3">
    <col style="width: 14%;" *ngIf="moduleType !== 3">
    <col style="width: 25%;">

  </ng-container>

</colgroup>
            <thead>
              <tr>
                <th scope="col">&nbsp;</th>
                <th scope="col">Fees</th>
                <th scope="col" class="text-center">Amount</th>
                <th scope="col">Type</th>
                <th scope="col" class="text-center">Value</th>
                <th scope="col" *ngIf="moduleType !== 3">Effective Date</th>
                <th scope="col" *ngIf="moduleType !== 3">Stop Date</th>
                <th scope="col">Reason<span *ngIf="reasonRequired" class="required">*</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of fees; trackBy: trackByFeeRow">
                <!-- Checkbox -->
                <td class="align-middle text-center">
                  <label class="pure-material-checkbox">
                    <input type="checkbox" *ngIf="moduleType == 3" permissionHandler [functId]="68" [elementType]="eNumElementTypes.INPUT" [action]="eNumActionTypes.EDIT"
                      [disabled]="readonly || item.FeesAndChargesId == 0" [(ngModel)]="item.selected" (ngModelChange)="checkFeesCharges($event,item.FeesAndChargesId,item)">
                    <input type="checkbox" *ngIf="moduleType == 1" permissionHandler [functId]="95" [elementType]="eNumElementTypes.INPUT"
                      [action]="eNumActionTypes.CREATE" [disabled]="readonly || !FeesEditRight || item.FeesAndChargesId == 0"
                      [(ngModel)]="item.selected" (ngModelChange)="checkFeesCharges($event,item.FeesAndChargesId,item)">
                      <input type="checkbox"  *ngIf="moduleType == 2" permissionHandler [moduleId]="11" [functId]="95"
                      [elementType]="eNumElementTypes.INPUT" [action]="eNumActionTypes.CREATE"
                      [disabled]=" readonly || !FeesEditRight || item.FeesAndChargesId == 0 || (moduleType == 2 && item.AppliedFeeDueID && !item.RecurringFeeId)"
                      [(ngModel)]="item.selected"
                      (change)="checkFeesCharges($event.target.checked,item.FeesAndChargesId, item)">
                    <span></span>
                  </label>
                </td>
                <!-- Fee Name -->
                <td class="align-middle" *ngIf="item.FeesAndChargesId !== 0 && item.ApplyManually === false">{{ item.Name }}</td>
                <td class="align-middle" *ngIf="item.ApplyManually === true">
  <select
    class="form-select"
    [(ngModel)]="item.FeesAndChargesId"
    (ngModelChange)="feeschargesChanged($event, item)"
    [disabled]="readonly || !manualFeesAndCharges.length">
    <option [ngValue]="0" disabled>Select</option>
    <option
      *ngFor="let feeItem of manualFeesAndCharges"
      [ngValue]="feeItem.FeesAndChargesId"
      [disabled]="disableOption ? disableOption(feeItem.FeesAndChargesId): false">
      {{ feeItem.Name }}
    </option>
  </select>
</td>
                <!-- Amount -->
                <td class="align-middle text-center">{{ item.Amount | currency }}</td>
                <!-- Type -->
                <td class="align-middle">{{ item.TypeName }}</td>
                <!-- Value -->
                <td class="align-middle">
                  <input type="number" min="0" step="0.01" class="form-control text-center inputresp"
                    [disabled]="readonly || !item.AllowToOverride || !(item.newlyAdded == undefined ? true : item.newlyAdded)"
                    [(ngModel)]="item.Value" (ngModelChange)="feesChanged($event,item.FeesAndChargesId,item)">
                  <div class="alert alert-danger" *ngIf="!readonly && item.IsError && item.AllowToOverride">
                    <span>Value should be between {{item.MinValue}} and {{item.MaxValue}}</span>
                  </div>
                </td>
                <!-- Effective Date -->
                <td class="align-middle" *ngIf="moduleType !== 3">
                  <ejs-datepicker class="form-control p-0 ejsgrid-height h-auto" [(ngModel)]="item.EffectiveDate"
                    (change)="effectiveDateChange($event,item.FeesAndChargesId,item)" [readonly]="readonly || !item.ApplyManually || !item.FeesAndChargesId"
                    (renderDayCell)="onLoadEffectiveDate($event)" format='MM/dd/yyyy' floatLabelType='Always'>
                  </ejs-datepicker>
                  <div class="alert alert-danger" *ngIf="!readonly && item.EffectiveDate == null">
                    <span>Please select Effective date</span>
                  </div>
                </td>
                <!-- Stop Date -->
                <td class="align-middle" *ngIf="moduleType !== 3">
                  <ejs-datepicker class="form-control p-0 ejsgrid-height h-auto" [(ngModel)]="item.StopDate"
                    (change)="StopDateChange($event,item.FeesAndChargesId,item)" (input)="onStopDateInput($event, item)"  (cleared)="onStopDateCleared(item)" (close)="onStopDateClose(item)"
                    [readonly]="!item.selected || disableStopDates(item) || (!item.RecurringFeeId && item.OneTimeFees)"
                      [ngClass]="{'disabled-datepicker':!item.RecurringFeeId && item.OneTimeFees}"
                    (renderDayCell)="onLoadStopDate($event,item)" format='MM/dd/yyyy'
                    floatLabelType='Always'>
                  </ejs-datepicker>
                    <div class="alert alert-danger" *ngIf="item.showStopDateError">
    <span>Please select Stop date</span>
  </div>
                </td>
                <!-- Notes -->
                <td class="align-middle">
                  <input type="text" class="form-control" [(ngModel)]="item.Notes"
                    (ngModelChange)="onNotesEntered($event,item.FeesAndChargesId,item)">
                  <div class="alert alert-danger" *ngIf="isReasonAdded(item)">
                    <span>Reason Required!</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>